module.exports = __webpack_public_path__ + "static/img/ic_favorite_sale_on@2x.7ea37af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_favorite_sale_on@2x.png
// module id = O6I7
// module chunks = 1